"use strict";

module.exports = require("./component/month-picker");